import { render, staticRenderFns } from "./InstructionView.vue?vue&type=template&id=94e719da&scoped=true&"
import script from "./InstructionView.vue?vue&type=script&lang=js&"
export * from "./InstructionView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionView.vue?vue&type=style&index=0&id=94e719da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e719da",
  null
  
)

export default component.exports